import type { AxiosError } from '@/shared/api';

export function isAxiosError(obj: unknown): obj is AxiosError {
  return typeof obj === 'object' && obj !== null && 'errorMessage' in obj && 'errorCode' in obj;
}
